"use client"

import { HStack } from "@chakra-ui/react/stack"
import { Stack } from "@chakra-ui/react/stack"
import { VStack } from "@chakra-ui/react/stack"
import { FC, ReactNode, useRef } from "react"
import { useInView } from "framer-motion"

import BlurReveal from "@/components/Animations/BlurReveal"
import Img from "@/components/Img"
import SectionTitle from "@/components/SectionTitle"

export interface SectionHeroProps {
  rightImg: string
  heading: ReactNode
  subHeading: string
  preface?: string
}

const SectionHero: FC<SectionHeroProps> = ({
  heading,
  preface = "work",
  rightImg,
  subHeading,
}) => {
  const sectionRef = useRef<HTMLDivElement>(null)
  const isInView = useInView(sectionRef, { once: true, margin: "-40px" })

  return (
    <VStack
      as="section"
      bgColor="bg.paper"
      borderBottom={"1px solid {colors.border}"}
      display="flex"
      gap={0}
      ref={sectionRef}
      rounded="0"
      w="full"
    >
      <Stack
        alignItems="center"
        borderLeft={"1px solid {colors.border}"}
        borderRight={"1px solid {colors.border}"}
        flexDirection={{ base: "column", lg: "row" }}
        gap={[0, 0, 0, "2rem", "4", "4rem"]}
        maxW="8xl"
        minHeight={"320px"}
        mx="auto"
        position="relative"
        textAlign={["center", "center", "left"]}
        w={"full"}
      >
        <HStack mb={[2, 2, 0]} width={{ base: "100%", lg: "50%" }}>
          <BlurReveal animateWhen={isInView} style={{ width: "100%" }}>
            <SectionTitle
              preface={preface}
              subTitle={subHeading}
              title={heading?.toString() ?? ""}
            />
          </BlurReveal>
        </HStack>
        <HStack flexGrow="1" paddingRight={[0, 0, 0, "2rem", "4rem"]}>
          <BlurReveal animateWhen={isInView} delay={0.15}>
            <Img
              alt="Work Page Hero Decorative Image"
              breakpointWidths={{
                base: "290",
                sm: "420",
                md: "380",
                lg: "500",
                xl: "620",
              }}
              fetchPriority="high"
              objectFit="contain"
              originalHeight={248}
              originalWidth={620}
              priority
              src={rightImg}
              width={["290px", "420px", "380px", "500px", "620px"]}
            />
          </BlurReveal>
        </HStack>
      </Stack>
    </VStack>
  )
}

export default SectionHero
